
import { Link } from 'react-router-dom';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';

export default function SitemapPage() {
  const siteStructure = [
    {
      title: 'Ana Sayfalar',
      links: [
        { name: 'Anasayfa', url: '/' },
        { name: 'İletişim', url: '/iletisim' },
        { name: 'Site Haritası', url: '/site-haritasi' }
      ]
    },
    {
      title: 'Hakkımızda',
      links: [
        { name: 'Kurumsal Profil', url: '/hakkimizda' },
        { name: 'Vizyon & Misyon', url: '/vizyon-misyon' },
        { name: 'Belgeler & Sertifikalar', url: '/belgeler' },
        { name: 'Çözüm Ortaklarımız', url: '/cozum-ortaklari' }
      ]
    },
    {
      title: 'Projeler',
      links: [
        { name: 'Tüm Projeler', url: '/projeler' },
        { name: 'Kiraya Sunulan Birimler', url: '/kiraya-sunulan' },
        { name: 'Arsa Değerlendirme', url: '/arsa-degerlendirme' }
      ]
    },
    {
      title: 'Blog',
      links: [
        { name: 'Blog Ana Sayfa', url: '/blog' },
        { name: 'İnşaat Teknolojileri', url: '/blog?kategori=insaat-teknolojileri' },
        { name: 'Proje Güncellemeleri', url: '/blog?kategori=proje-guncellemeleri' },
        { name: 'Sektör Haberleri', url: '/blog?kategori=sektor-haberleri' },
        { name: 'Sürdürülebilirlik', url: '/blog?kategori=surdurulebilirlik' }
      ]
    },
    {
      title: 'Hukuki Sayfalar',
      links: [
        { name: 'KVKK Aydınlatma Metni', url: '/kvkk' },
        { name: 'Çerez Politikası', url: '/cerez-politikasi' }
      ]
    }
  ];

  const projectExamples = [
    { name: 'Ataşehir Residence', url: '/projeler/1' },
    { name: 'Kadıköy Plaza', url: '/projeler/2' },
    { name: 'Beşiktaş Towers', url: '/projeler/3' },
    { name: 'Ankara Business Center', url: '/projeler/4' },
    { name: 'İzmir Coastal Residence', url: '/projeler/5' },
    { name: 'Bursa Green Valley', url: '/projeler/6' }
  ];

  const blogExamples = [
    { name: 'Modern İnşaat Teknolojilerinin Geleceği', url: '/blog/1' },
    { name: 'Ataşehir Residence Projesi Güncellemesi', url: '/blog/2' },
    { name: 'Sürdürülebilir İnşaat Malzemeleri Rehberi', url: '/blog/3' },
    { name: '2024 İnşaat Sektörü Trend Analizi', url: '/blog/4' },
    { name: 'Akıllı Bina Sistemleri ve IoT Entegrasyonu', url: '/blog/5' },
    { name: 'Kadıköy Plaza Projesi Tamamlandı', url: '/blog/6' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-24 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">
              Site Haritası
            </h1>
            <p className="text-[16px] text-gray-600 max-w-3xl mx-auto">
              Web sitemizde yer alan tüm sayfalar ve bölümler
            </p>
          </div>
        </div>
      </section>

      {/* Site Haritası */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {siteStructure.map((section, index) => (
              <Card key={index}>
                <h2 className="text-[18px] font-semibold text-[#0e3851] mb-4">
                  {section.title}
                </h2>
                <ul className="space-y-2">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link 
                        to={link.url}
                        className="text-[14px] text-gray-600 hover:text-[#0e3851] transition-colors flex items-center"
                      >
                        <i className="ri-arrow-right-s-line mr-1 text-[12px]"></i>
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Proje Detayları */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-[22px] font-semibold text-[#0e3851] mb-8 text-center">
            Proje Detay Sayfaları
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projectExamples.map((project, index) => (
              <Card key={index} hover>
                <Link 
                  to={project.url}
                  className="flex items-center text-[15px] text-gray-700 hover:text-[#0e3851] transition-colors"
                >
                  <i className="ri-building-line mr-3 text-[16px]"></i>
                  {project.name}
                  <i className="ri-external-link-line ml-auto text-[14px]"></i>
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Yazıları */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-[22px] font-semibold text-[#0e3851] mb-8 text-center">
            Blog Yazıları
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogExamples.map((blog, index) => (
              <Card key={index} hover>
                <Link 
                  to={blog.url}
                  className="flex items-center text-[15px] text-gray-700 hover:text-[#0e3851] transition-colors"
                >
                  <i className="ri-article-line mr-3 text-[16px]"></i>
                  <span className="line-clamp-2">{blog.name}</span>
                  <i className="ri-external-link-line ml-auto text-[14px] flex-shrink-0"></i>
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* İstatistikler */}
      <section className="py-16 bg-[#0e3851] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-[22px] font-semibold mb-4">Site İstatistikleri</h2>
            <p className="text-[16px] text-gray-300">
              Web sitemizde yer alan içerik sayıları
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-[32px] font-bold mb-2">15+</div>
              <div className="text-[14px] text-gray-300">Ana Sayfa</div>
            </div>
            <div className="text-center">
              <div className="text-[32px] font-bold mb-2">6</div>
              <div className="text-[14px] text-gray-300">Proje Detayı</div>
            </div>
            <div className="text-center">
              <div className="text-[32px] font-bold mb-2">6</div>
              <div className="text-[14px] text-gray-300">Blog Yazısı</div>
            </div>
            <div className="text-center">
              <div className="text-[32px] font-bold mb-2">25+</div>
              <div className="text-[14px] text-gray-300">Toplam Sayfa</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
